export default "__VITE_ASSET__BUCZGvM$__"